<template>
  <div class="nav-item mb-0" role="tab" :class="activeClass">
    <router-link
      v-if="routeTo"
      :to="{ name: routeTo, params: routeParams || {}, query: query() }"
      active-class="route-record-active"
      exact-active-class="route-record-exact-active"
      class="nav-link"
      :class="{'router-link-active': isActive, disabled: !canNavigate}"
      :aria-disabled="(!canNavigate).toString()"
      :tabindex="canNavigate ? null : -1"
      role="presentation"
      @click.native="onTabClick"
      >
      <div class="scope-tab-content">
        <span class="label">{{ label ? label : $t(labelKey) }}</span>
        <!-- <span v-if="!isLoading && count >= 0" class="count">{{ formattedCount }}</span>
        <span v-else-if="!isLoading" class="count">?</span>
        <span v-else class="count loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </span> -->
      </div>
    </router-link>
    <a
      v-else
      :href="href"
      class="nav-link"
      :class="activeClass"
      role="presentation">
      <div class="scope-tab-content">
        <span class="label">{{ label ? label : $t(labelKey) }}</span>
        <span v-if="!isLoading && count >= 0" class="count">{{ formattedCount }}</span>
        <span v-else-if="!isLoading" class="count">?</span>
        <span v-else class="count loading-dots">
          <span class="dot"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "SearchScopeSelectItem",
  props: {
    routeTo: String,
    href: String,
    isActive: Boolean,
    label: String,
    labelKey: String,
    count: Number,
    queryParams: Object,
    routeParams: Object,
    isLoading: Boolean
  },
  computed: {
    activeClass() {
      return this.isActive ? 'router-link-active' : 'router-link-inactive';
    },
    canNavigate() {
      return (this.count || 0) > 0;
    },
     formattedCount() {
      if (this.count === null || this.count === undefined) return '';
      
      const countStr = this.count.toString();
      const reversed = countStr.split('').reverse();
      const chunks = [];
      
      for (let i = 0; i < reversed.length; i += 3) {
        chunks.push(reversed.slice(i, i + 3).join(''));
      }
      
      return chunks.join(' ').split('').reverse().join('');
    },
  },
  methods: {
    onTabClick(event) {
      if (!this.canNavigate) {
        event.preventDefault();
      }
    },
    query() {
      return {...(this.queryParams.query || {}), locale: this.$route.query.locale};
    }
  }
}
</script>

<style lang="scss" scoped>
/* Loading Animation für Count */
.count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 20px;
  line-height: 20px;
  border: 1px solid;
  border-radius: 10px;
  padding: 0.1rem 0.5rem;
}

.loading-dots {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  min-width: 20px;
  justify-content: center;
  min-height: 20px;
}

.loading-dots .dot {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #0e47cb;
  animation: loading-bounce 1.4s infinite ease-in-out both;
}

.loading-dots .dot:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots .dot:nth-child(2) {
  animation-delay: -0.16s;
}

.loading-dots .dot:nth-child(3) {
  animation-delay: 0s;
}

@keyframes loading-bounce {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.nav-item {
  border: 1px solid #c0c0c0;
  border-radius: 0;
  box-sizing: border-box;
  margin-right: -1px;
  position: relative; /* Verhindert Verschiebung */
  z-index: 1;

  &:first-child {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  &:last-child {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem ;
    margin-right: 0;
  }

  &.router-link-active {
    border-color: #0e47cb;
    z-index: 2; /* Aktives Element über anderen */
  }

  .router-link-active {
    background-color: #0e47cb;
  }

  .nav-link {
    outline: none !important;
    box-shadow: none !important; /* Entfernt Bootstrap focus shadow */
    
    &:focus,
    &:active,
    &:focus-visible {
      outline: none !important;
      box-shadow: none !important;
    }
  }
}

.nav-link {
  outline: none !important;
  box-shadow: none !important;
  border: none !important; /* Falls Bootstrap einen Border hinzufügt */
  
  &:focus,
  &:active,
  &:focus-visible {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }
}

.label {
  margin-right: 0.5rem;
}

a.router-link-inactive {
  color: #0e47cb !important;
}
a.router-link-active {
  color: white !important;
}
a.router-link-active .count {
  background-color: white;
  border-color: white;
  color: #0e47cb;
}

a.nav-link.disabled {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}

.nav-item {
  width: 100%
}

.scope-tab-content {
  white-space: nowrap;
  span {
    white-space: nowrap;
  }
}

@media screen and (max-width: 767.5px) {
  .nav-item {
    border-color: #0e47cb;
  }
}
@media screen and (max-width: 992px) {
  .scope-tab-content {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
}
</style>
